module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_8004.f372e3a2.png";